module.exports = "/3068/img/qrcode.a7c8778c.png";